// ============================================================================
// LE TIROIR LATÉRAL — le panneau qui entre par le bord et laisse voir l'écran qu'il complète.
//
// ⚠️ IL N'EST PAS UNE MODALE, et la différence n'est pas cosmétique : une modale INTERROMPT pour faire
// une chose et se referme, un tiroir RÈGLE ce qu'on regarde derrière lui. D'où un voile plus clair et
// SANS flou — on doit continuer à lire l'écran qu'on est en train de personnaliser, sinon on règle à
// l'aveugle. C'est aussi pourquoi il entre par translation depuis SON bord : il vient de quelque part.
//
// SOURCE : relevé du panneau « Personnaliser » de la maquette du back-office (2026-08-18).
// ============================================================================
import { Z_LAYERS } from './z';

export const DRAWER = {
  width: 380,
  /** Sur un écran étroit, il ne colle jamais au bord opposé : la page reste visible et refermable. */
  maxWidthVw: 92,
  /** ⚠️ Portée VERS LA GAUCHE : l'ombre doit tomber sur l'écran, pas dans le vide hors cadre. */
  shadow: '-14px 0 44px -14px rgba(12,14,16,.3)',
  head: { padV: 18, padH: 20, gap: 12, titleSize: 16.5, titleTracking: '-0.02em', subSize: 12.5 },
  body: { padV: 14, padH: 20 },
  /** Pied de NOTE (ce que le panneau ne fait pas), pas de boutons : le tiroir enregistre au geste. */
  foot: { padV: 14, padH: 20, size: 12 },
  close: { size: 34, radius: 'ctrl', bg: 'ink-100', fg: 'ink-600', icon: 16, iconStroke: 2 },
  anim: { enterMs: 200, easing: 'cubic-bezier(.2,.7,.3,1)', slideFromPx: 16 },
} as const;

export const DRAWER_SCRIM = {
  /** ⚠️ Plus CLAIR que celui de la modale (0,55) et sans flou : il assombrit sans masquer. */
  alpha: 0.35,
  z: Z_LAYERS.drawerScrim,
} as const;
